import React from "react";
import { Outlet } from "react-router-dom";

import { Container } from "@mui/material";

import { styled } from '@mui/material/styles';

const StyledContainer = styled(Container)(({ theme }) => ({
  background: theme.palette.background.default,
  transition: theme.transitions.create(['background-color'])
}));

const MainLayout = () => {
  return (
    <StyledContainer maxWidth={false} sx={{
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <Outlet />
    </StyledContainer>
  );
};
export default MainLayout;
